import { registerSW } from 'virtual:pwa-register';
import 'themes/index.css';
import 'antd/dist/antd.variable.min.css';
import 'react-contexify/dist/ReactContexify.css';

import { injectGlobal } from '@emotion/css';
import '@emotion/styled';
import ysbth from 'assets/fonts/ysbth.ttf';
// import { insertLazadaSdkScript } from 'utils/scripts';
// import { captureException } from '@sentry/react';
import { isQuickChat, isTfsoftware } from 'productLine';
import { isInBrowser } from 'utils/is';

if (isInBrowser) {
  console.log('register sw');
  registerSW();
}

injectGlobal`
  @font-face {
    font-family: you she biao ti hei;
    src: url(${ysbth});
  }
  * {
    overscroll-behavior: auto;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: var(--fett-scrollbar-thumb, hsla(0, 0%, 70.6%, 0.5));
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
  .react-contexify {
    z-index: 9999999999;
  }
  .ant-select-selector:after {
    visibility: hidden;
  }
  body {
    background: var(--fett-bg-app);
    color: var(--fett-text-primary);
  }
  .ant-dropdown-menu-sub > .ant-dropdown-menu-item {
    padding: 5px 16px;
  }
`;

// insertLazadaSdkScript().catch((err) => {
//   captureException(err, {
//     extra: { location: window.location },
//     tags: {
//       module: 'loadLazadaSdkFailed',
//     },
//   });
// });

if (isQuickChat) {
  const link = document.querySelector("link[rel~='icon']") as any;
  if (link) {
    link.href = '/favicon-quickchat.ico';
  }
} else if (isTfsoftware) {
  const link = document.querySelector("link[rel~='icon']") as any;
  if (link) {
    link.href = '/favicon-tfsoftware.ico';
  }
}

if (!window.requestIdleCallback) {
  window.requestIdleCallback = window.setTimeout as any;
}
if (!window.requestAnimationFrame) {
  window.requestAnimationFrame = window.setTimeout;
}

// 浏览器整页翻译（如 Google 翻译）会把文本节点包进 <font> 标签，篡改 React 管理的 DOM，
// 导致 React 17 commit 阶段 removeChild/insertBefore 抛 NotFoundError 整页崩溃
// （facebook/react#11538）。节点已被移走时跳过操作而不是抛错。
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function <T extends Node>(child: T): T {
  if (child.parentNode !== this) {
    return child;
  }
  return originalRemoveChild.call(this, child) as T;
};
const originalInsertBefore = Node.prototype.insertBefore;
Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
  if (referenceNode && referenceNode.parentNode !== this) {
    return newNode;
  }
  return originalInsertBefore.call(this, newNode, referenceNode) as T;
};
